import { render, staticRenderFns } from "./FarmActivity.vue?vue&type=template&id=2fe20a25&scoped=true"
import script from "./FarmActivity.vue?vue&type=script&lang=js"
export * from "./FarmActivity.vue?vue&type=script&lang=js"
import style0 from "./FarmActivity.vue?vue&type=style&index=0&id=2fe20a25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe20a25",
  null
  
)

export default component.exports